import { gql, TypedDocumentNode } from '@apollo/client/core';
import type {
  ChangePasswordMutation,
  ChangePasswordMutationVariables,
  LoginMutation,
  LoginMutationVariables,
  LogoutMutation,
  LogoutMutationVariables,
  RefreshTokenMutation,
  RefreshTokenMutationVariables,
  RegisterMutation,
  RegisterMutationVariables,
  RequestResetPasswordMutation,
  RequestResetPasswordMutationVariables,
  ResetPasswordMutation,
  ResetPasswordMutationVariables,
  UserInfoQuery,
  UserInfoQueryVariables,
} from 'gql/graphql';

export const LOGIN_QUERY = gql`
  mutation Login($email: String!, $password: String!) {
    login(email: $email, password: $password) {
      __typename
      ... on LoginSuccess {
        account {
          email
          profile {
            firstName
            lastName
          }
        }
        token
      }
    }
  }
` as TypedDocumentNode<LoginMutation, LoginMutationVariables>;

export const LOGOUT_QUERY = gql`
  mutation Logout {
    logout {
      __typename
    }
  }
` as TypedDocumentNode<LogoutMutation, LogoutMutationVariables>;

export const REGISTER_QUERY = gql`
  mutation Register(
    $firstName: String!
    $lastName: String!
    $email: String!
    $password: String!
  ) {
    register(
      email: $email
      firstName: $firstName
      lastName: $lastName
      password: $password
    ) {
      ... on RegisterSuccess {
        account {
          email
          profile {
            firstName
            lastName
          }
        }
        token
      }
      ... on EmailInvalid {
        issue
      }
    }
  }
` as TypedDocumentNode<RegisterMutation, RegisterMutationVariables>;

export const USERINFO_QUERY = gql`
  query UserInfo {
    account {
      profile {
        firstName
        lastName
      }
      email
    }
  }
` as TypedDocumentNode<UserInfoQuery, UserInfoQueryVariables>;

// todo - update this mutation when token will be fetched from cookies
export const REFRESH_MUTATION = gql`
  mutation RefreshToken {
    refreshToken {
      token
    }
  }
` as TypedDocumentNode<RefreshTokenMutation, RefreshTokenMutationVariables>;

export const CHANGE_PASSWORD_MUTATION = gql`
  mutation ChangePassword($newPassword: String!, $oldPassword: String!) {
    changePassword(newPassword: $newPassword, oldPassword: $oldPassword) {
      __typename
    }
  }
` as TypedDocumentNode<ChangePasswordMutation, ChangePasswordMutationVariables>;

export const REQUEST_RESET_PASSWORD_MUTATION = gql`
  mutation RequestResetPassword($email: String!) {
    requestResetPassword(email: $email) {
      __typename
    }
  }
` as TypedDocumentNode<
  RequestResetPasswordMutation,
  RequestResetPasswordMutationVariables
>;

export const RESET_PASSWORD_MUTATION = gql`
  mutation ResetPassword($key: String!, $password: String!) {
    resetPassword(key: $key, password: $password) {
      __typename
    }
  }
` as TypedDocumentNode<ResetPasswordMutation, ResetPasswordMutationVariables>;
